<template>
  <section class="agb-page">
    <p class="section-title">1. Geltungsbereich</p>
    <ul>
      <li>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge
        zwischen der Tuemedia IT Solutions (nachfolgend "Anbieter") und dem
        Benutzer (nachfolgend "Kunde") über die Nutzung der SaaS-Plattform
        ChronoFox, abrufbar unter
        <a href="https://chronofox.de/" target="_blank">https://chronofox.de/</a
        >.
      </li>

      <li>
        Der Anbieter richtet sein Angebot ausschließlich an unternehmerische
        Kunden und schließt keine Verträge mit Verbrauchern ab. Als Verbraucher
        gilt jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
        abschließt, die überwiegend nicht ihrer gewerblichen oder selbständigen
        beruflichen Tätigkeit zuzurechnen sind.
      </li>

      <li>
        Etwaige Geschäftsbedingungen des Kunden sind nicht Bestandteil des
        Vertrages. Der Anbieter widerspricht deren Geltung, sofern sie nicht
        ausdrücklich und individuell in Textform vereinbart werden.
      </li>
    </ul>

    <p class="section-title">2. Leistungsbeschreibung</p>
    <p>
      ChronoFox ist eine webbasierte Softwarelösung zur Zeiterfassung und
      Projektverwaltung, die es Benutzern ermöglicht, Arbeitszeiten zu erfassen,
      Projekte zu verwalten und verschiedene Analysen und Berichte zu erstellen.
      Die Software ist als Cloud-Lösung konzipiert, die jederzeit und von jedem
      internetfähigen Gerät aus zugänglich ist. Die Plattform bietet eine
      benutzerfreundliche Oberfläche zur einfachen Verwaltung von
      Zeitaufzeichnungen, Aufgaben und Projekten, sowie zur Erstellung von
      detaillierten Auswertungen und Berichten.
    </p>

    <p class="section-title">3. Registrierung und Vertragsschluss</p>
    <ul>
      <li>
        Die Nutzung von ChronoFox setzt eine Registrierung voraus. Die Sicht der
        Webseite ist auch ohne Registrierung möglich.
      </li>
      <li>
        Durch Abschluss der Registrierung und Bestätigung durch den Anbieter
        kommt ein Vertrag zustande.
      </li>
      <li>
        Der Anbieter behält sich das Recht vor, Registrierungsanfragen nach
        eigenem Ermessen, aber nicht willkürlich abzulehnen. Insbesondere bei
        unvollständigen Angaben, fehlender Bonität, Compliance-Risiken oder
        anderen Gründen, die die Vertragserfüllung gefährden, kann der Anbieter
        die Registrierung ablehnen.
      </li>
    </ul>

    <p class="section-title">4. Nutzungsrechte</p>
    <ul>
      <li>
        Der Kunde erhält ein nicht-exklusives, nicht-übertragbares Recht zur
        Nutzung der Software.
      </li>
      <li>
        Der Kunde darf die Software nicht verändern, vervielfältigen oder
        weiterverkaufen.
      </li>
    </ul>

    <p class="section-title">5. Entgelte und Zahlungsbedingungen</p>
    <ul>
      <li>Die Nutzung von ChronoFox kann kostenpflichtig sein.</li>
      <li>
        Zahlungen erfolgen grundsätzlich im Voraus oder kurz nach Beginn der
        Nutzung.
      </li>
      <li>
        Da ChronoFox ein Abonnement-Modell ist, erfolgt die Abrechnung nach
        Abrechnungsperioden (z.B. monatlich). Für jede Abrechnungsperiode wird
        standardmäßig eine Rechnung im Voraus oder kurz nach Beginn der
        neubeginnenden Abrechnungsperiode erstellt.
      </li>
      <li>
        Die ingesamt für eine Abrechnungsperiode fällige Preis ist abhängig von
        der Anzahl der in dem Abonnement befindlichen Benutzer. Diese definiert
        sich nicht über die Anzahl an real angelegter und aktiver Benutzer,
        sondern über die Anzahl an Lizenzen, die der Kunde erworben hat.
      </li>
      <li>
        Die bestellte Lizenzmenge kann für jede folgende Abrechnungsperiode
        runter- oder hochgesetzt werden. Für die aktuelle Periode ist es nur
        möglich, die Anzahl der Benutzer zu erhöhen.
      </li>
      <li>
        Für eine Erhöhung der Lizenzanzahl innerhalb der aktuellen
        Abrechnungsperiode wird der Preis nicht anteilig berechnet, sondern
        vollständig für die gesamte Abrechnungsperiode rückwirkend in Rechnung
        gestellt. Der Kunde wird hierüber informiert bevor die Erhöhung
        abgeschlossen wird. Es steht dem Kunden frei diese Erhöhung alternativ
        erst zum Beginn der nächsten Abrechnungsperiode zu beantragen, um eine
        rückwirkende Abrechnung zu vermeiden.
      </li>
      <li>
        Die Dauer einer Abrechnungsperiode wird im Rahmen des Bestellvorgangs
        angezeigt und kann je nach gewähltem Tarif variieren.
      </li>
      <li>
        ChronoFox bietet standardmäßig eine kostenlose Testphase an. Nach Ablauf
        der Testphase wird das Abonnement automatisch in ein kostenpflichtiges
        Abonnement umgewandelt, sofern der Kunde nicht kündigt. Über die
        automatische Umwandlung wird der Kunde vor Abschluss der Testphase
        informiert.
      </li>
      <li>
        Bei Zahlungsverzug kann der Anbieter den Zugang nach Versenden einer
        Mahnung mit angemessener Fristsetzung sperren. Die Sperrung erfolgt nach
        fruchtlosem Ablauf der gesetzten Frist.
      </li>
    </ul>

    <p class="section-title">6. Verfügbarkeit und Haftung</p>
    <ul>
      <li>
        Der Anbieter bemüht sich um eine hohe Verfügbarkeit der Software.
        Geplante Wartungsarbeiten werden, soweit möglich, im Voraus angekündigt.
      </li>
      <li>
        Der Anbieter haftet für Schäden nur bei Vorsatz oder grober
        Fahrlässigkeit.
      </li>
      <li>
        Bei einfacher Fahrlässigkeit haftet der Anbieter nur für die Verletzung
        wesentlicher Vertragspflichten (Kardinalpflichten). In diesem Fall ist
        die Haftung auf den vertragstypischen, vorhersehbaren Schaden
        beschränkt.
      </li>
      <li>
        Für Datenverluste haftet der Anbieter nur, wenn diese durch eine
        vorsätzliche oder grob fahrlässige Pflichtverletzung verursacht wurden.
        Der Kunde ist verpflichtet, in regelmäßigen Abständen Sicherungskopien
        seiner Daten zu erstellen, um möglichen Schaden zu minimieren.
      </li>
      <li>
        Eine weitergehende Haftung des Anbieters, insbesondere für entgangenen
        Gewinn, indirekte Schäden oder Folgeschäden, ist – soweit gesetzlich
        zulässig – ausgeschlossen.
      </li>
    </ul>

    <p class="section-title">7. Datenschutz</p>
    <ul>
      <li>
        Der Anbieter verarbeitet personenbezogene Daten gemäß der
        Datenschutzerklärung.
      </li>
      <li>Eine Weitergabe an Dritte erfolgt nur zur Vertragserfüllung.</li>
    </ul>

    <p class="section-title">8. Vertragslaufzeit und Kündigung</p>
    <ul>
      <li>Der Vertrag wird auf unbestimmte Zeit geschlossen.</li>
      <li>
        Der Anbieter kann mit einer Frist von 4 Wochen zum Monatsende kündigen.
      </li>
      <li>
        Wie in 1.2 beschrieben, richtet sich das Angebot ausschließlich an
        unternehmerische Kunden. Sollte der Kunde dennoch ein Verbraucher sein
        und durch Falschangaben den Vertrag erschlichen haben, ist der Anbieter
        berechtigt, eine Stellungnahme des Kunden zu verlangen und im Zweifel
        den Vertrag mit Setzung einer angemessenen Frist zu kündigen.
      </li>
    </ul>

    <p class="section-title">9. Support und Wartung</p>
    <ul>
      <li>
        Supportleistungen werden während der üblichen Geschäftszeiten angeboten.
      </li>
      <li>
        Support wird nur für kostenpflichtige Abonnements garantiert. Für
        kostenlose Abonnements oder Testphasen wird kein Support garantiert.
      </li>
      <li>
        Wenn keine Supportleistungen vereinbart wurden, erfolgt der Support ohne
        Garantie auf Erfolg. Das heißt der Anbieter ist nicht verpflichtet,
        Supportleistungen zu erbringen oder zu gewährleisten abseits der
        gesetzlichen Vorgaben.
      </li>
      <li>
        Updates und Wartungsarbeiten können zu temporären Einschränkungen
        führen.
      </li>
    </ul>

    <p class="section-title">10. Haftung des Kunden</p>
    <ul>
      <li>
        Der Kunde ist für die Sicherheit seiner Zugangsdaten verantwortlich.
      </li>
      <li>Unbefugte Nutzung muss sofort gemeldet werden.</li>
    </ul>

    <p class="section-title">11. Nutzungseinschränkungen und Sperrung</p>
    <ul>
      <li>Missbräuchliche Nutzung kann zur Sperrung des Zugangs führen.</li>
      <li>
        Verstoß gegen gesetzliche Bestimmungen kann zur Vertragsbeendigung
        führen.
      </li>
    </ul>

    <p class="section-title">12. Referenznennung</p>
    <ul>
      <li>
        Der Anbieter darf den Kunden als Referenz nennen. Der Anbieter darf den
        Namen des Kunden sowie das für dessen Firmierung genutzte Logo als
        Referenz in seiner Werbung verwenden. Dies geschieht ausschließlich auf
        eine übliche und für den Kunden zumutbare Weise.
      </li>
      <li>Der Kunde kann der Nennung und Nutzung jederzeit widersprechen.</li>
    </ul>

    <p class="section-title">13. Änderungen der AGB</p>
    <ul>
      <li>
        Der Anbieter kann diese AGB ändern, sofern die Änderungen für den Kunden
        zumutbar sind.
      </li>
      <li>
        Änderungen, die lediglich sprachliche Anpassungen oder Klarstellungen
        enthalten und keine Auswirkungen auf bestehende Rechte oder Pflichten
        haben, treten nach einer Frist von vier Wochen in Kraft, sofern der
        Kunde nicht widerspricht.
      </li>
      <li>
        Wesentliche Änderungen, insbesondere solche, die die Leistungen,
        Entgelte oder wesentliche Vertragspflichten betreffen, erfordern die
        aktive Zustimmung des Kunden. Der Anbieter wird den Kunden über solche
        Änderungen mindestens vier Wochen vor Inkrafttreten informieren.
      </li>
      <li>
        Sollte der Kunde einer wesentlichen Änderung nicht zustimmen, steht ihm
        das Recht zu, den Vertrag zum Zeitpunkt des Inkrafttretens der Änderung
        außerordentlich zu kündigen.
      </li>
    </ul>

    <p class="section-title">14. Schlussbestimmungen</p>
    <ul>
      <li>Es gilt das Recht der Bundesrepublik Deutschland.</li>
      <li>Gerichtsstand ist der Sitz des Anbieters.</li>
    </ul>

    <p class="section-title">15. Salvatorische Klausel</p>
    <p>
      Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, wird
      die Wirksamkeit der übrigen Bestimmungen hiervon nicht berührt. Anstelle
      der unwirksamen Bestimmung gilt die gesetzliche Regelung.
    </p>
  </section>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "website",
});

useSeoMeta({
  title: "AGB" + " - " + "ChronoFox",
});
</script>

<style scoped>
.agb-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 60px 20px 80px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.8;
  color: #2c3e50;
}

.section-title {
  color: var(--t-accent);
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  padding-bottom: 0.5rem;
  border-bottom: 3px solid var(--t-accent);
}

.agb-page > p:first-child {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: #34495e;
}

p {
  margin-bottom: 1.2rem;
  font-size: 1.05rem;
  text-align: justify;
}

ul {
  margin-bottom: 2rem;
  margin-left: 1.5rem;
  list-style: decimal;
}

ul li {
  margin-bottom: 1rem;
  padding-left: 0.5rem;
}

a {
  color: var(--t-accent);
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

a:hover {
  text-decoration: underline;
  color: var(--secondary-text-color);
}

@media (max-width: 768px) {
  .agb-page {
    padding: 40px 15px 60px;
  }

  .section-title {
    font-size: 1.3rem;
    margin-top: 2rem;
  }

  p {
    font-size: 1rem;
  }
}
</style>
